

















import { mapState } from "vuex";
import Vue from "vue";
import {UtilityHelper} from "@/helpers/UtilityHelper";

export default Vue.extend({
  name: "progess-bar",
  data() {
    return {
      isVisibleProgressBar: true,
      TRANSLATION_KEY: "ProgressBar",
    };
  },
  mounted(): void {
    this.checkRoute();
  },
  methods: {
    checkRoute(): void {
      if (this.$route.name === "newLogin" || this.$route.name === "restart") {
        this.isVisibleProgressBar = false;
      } else {
        if (!this.isVisibleProgressBar) {
          this.isVisibleProgressBar = true;
        }
      }
    },
    adjustTextProgressBar(): string {
      const { timeToFinish } = this;

      if (timeToFinish >= 5 || timeToFinish === 0) {
        return "minute";
      } else if (timeToFinish === 1) {
        return "singularMinute";
      } else {
        return "minutes";
      }
    },
  },
  watch: {
    $route(): void {
      if (this.$route.name === "newLogin" || this.$route.name === "restart") {
        this.isVisibleProgressBar = false;
      } else {
        if (!this.isVisibleProgressBar) {
          this.isVisibleProgressBar = true;
        }
      }
    },
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper
    },
    ...mapState(["timeToFinish"]),
  },
});
